import Channel from 'twilio-chat/lib/channel'
import Client from 'twilio-chat';
import Message from 'twilio-chat/lib/message'
import * as AccessManager from 'twilio-common'
import { Actions as ChatActions } from '../../actions/chat'
import { MessageAttributes, ChatMessage } from '../../types/ChatMessage'
import { store } from '../../index'
import { Api } from '../api/api'


export class TwilioChatService {
    private static _instance: TwilioChatService
    private accessManager: any
    private client: Client
    private channel: Channel.Channel
    private messages: Message.Message[]
    public  initializing: boolean;

    public static getInstance(): TwilioChatService {

        if (this._instance === undefined) {
            this._instance = new TwilioChatService()
        }
        return this._instance
    }
    constructor() {
        console.log('Service Twilio client')
    }

    public get Client(): Client {
        if(this.client == null)
        {
            throw new Error('Client not initialized')
        }
        return this.client
    }


    public get Channel(): Channel.Channel {
        if (this.channel == null) {
            throw new Error('Channel not initialized')
        }
        return this.channel
    }

    public initializeAccessManager(twilioToken: string): boolean {
        console.log('testAAA', AccessManager)
        this.accessManager = AccessManager.AccessManager(twilioToken)
        console.log(this.accessManager)
        this.accessManager.on('tokenWillExpire', () => {
            console.log('Update token')
            Api.getTwilioToken().then(twilioToken => {
                let token = JSON.parse(twilioToken)
                this.accessManager.updateToken(token)
            })
                .catch(error => {
                    console.log('get twilio token', error)
                })

        })
        if (this.accessManager === null) {
            return false
        } else {
            return true
        }
    }

    public async initializeClient(twilioToken: string) {
        console.log('Initialize client')
        this.client = await Client.create(twilioToken)
        this.client.on('Error', (args) => {
            console.log('Error Create Client: ', args)
        })
        this.client.on('tokenExpired', () => {
            console.log('tokenExpired')
            Api.getTwilioToken().then(twilioToken => {
                let token = JSON.parse(twilioToken)
                this.accessManager.updateToken(token)
            })
                .catch(error => {
                    console.log('get twilio token', error)
                })
        })
    }

    public async moveChannel(channel: Channel.Channel, uniqueName: string):Promise<Channel.Channel>{
        await channel.updateUniqueName(uniqueName);
        return channel;
    }


    public async createChannel(inviteCode: string, channelFriendlyName?: string): Promise<Channel.Channel|undefined> {
        console.log('Create Channel')
        let name = channelFriendlyName ? channelFriendlyName : 'General'
        let arrayName: String[] = name.split(' ')
        arrayName[0] = arrayName[0] + '\'s'
        name = arrayName.join(' ')

        let channel:Channel.Channel|undefined = undefined;
        try {
            channel = await this.client.getChannelByUniqueName(inviteCode);
            if (!!channel) {
                this.channel = channel;
                return channel;
            }
        }catch (e) {
            console.log(e);
        }

        try {
            channel = await this.client.createChannel({friendlyName: name, uniqueName: inviteCode});
            this.channel = channel;
        }
        catch(e){
            console.log(e);
        }

        return channel;
    }

    public subscribeToNewMessages = () => {
        if (this.channel == null) {
            throw new Error('Channel is not initialized')
        }

        this.channel.on('messageAdded', this.onNewMessageAddedCallback)
    }

    private onNewMessageAddedCallback = (message: Message.Message) => {
        console.log(message.author + ': ' + message.body)
        this.messages.push(message)

        ChatActions.AddChatMessage(this.mapMessageObj(message))(store.dispatch)
    }

    public removeMessageAddedListener = () => {
        if (this.channel == null) {
            //throw new Error('Channel is not initialized')
            console.log('Chanel is not initialized')
            return
        }
        if (this.channel.listenerCount('messageAdded') > 0) {
            this.channel.removeListener('messageAdded', this.onNewMessageAddedCallback)
        }
    }

    public joinChannel(channel:Channel.Channel): Promise<boolean> {
        this.channel = channel;

        return new Promise<boolean>((resolve, reject) => {
            this.channel.join().then(() => {
                console.log('Join Channel')
                this.removeMessageAddedListener()
                this.channel.on('messageAdded', this.onNewMessageAddedCallback)

                this.channel.on('typingStarted', (member) => { console.log(member.identity + ' started typing...') })
                this.channel.on('typingEnded', (member) => { console.log(member.identity + ' stopped typing...') })
                this.channel.on('memberAdded', (member) => { console.log(member.identity + ' joined ' + this.channel.friendlyName) })
                resolve(true)
            }).catch((errorJoin) => {
                this.removeMessageAddedListener()
                this.channel.on('messageAdded', this.onNewMessageAddedCallback)
                console.log('Error Join: ', errorJoin)
                reject(errorJoin)
            })
        })
    }

    public async getChannelMembers() {
        if (this.channel == null) {
            throw new Error('Chanel not initialized')
        }
        return await this.channel.getMembers()
    }

    public async findMemberInChanelMembersByIdentity(identity: string) {
        let channelMembers = await this.getChannelMembers()
        console.log(channelMembers)
        if (channelMembers && channelMembers.length > 0) {
            let index = channelMembers.findIndex(member => { return member.identity == identity })
            return (index != -1)
        }
        return false
    }

    public sendMessage(message: string, messageAttributes?: MessageAttributes) {
        this.channel.sendMessage(message, messageAttributes).then((val) => {
            this.channel.advanceLastConsumedMessageIndex(val)
        })
    }

    public getMessages(): Promise<ChatMessage[]> {
        return new Promise<ChatMessage[]>((resolve, reject) => {
            this.channel.getMessagesCount().then((count) => {
                console.log('Messages Count: ', count)
                if (count === 0) {
                    resolve([])
                }
                this.channel.getMessages(count).then((messages) => {
                    this.messages = messages.items

                    resolve(this.mapMessagesObj(messages.items))
                }).catch((error) => {
                    console.log('Error: ', error)
                    reject(error)
                })
            }).catch((error) => {
                console.log('Get Messages Count Error: ', error)
            })
        })
    }

    public async getChannel(inviteCode: string) {
        return new Promise<boolean>((resolve, reject) => {
            console.log('Get Channel: ', inviteCode)
            this.client.getChannelByUniqueName(inviteCode).then((channel) => {
                console.log('Connect channel')
                if (channel !== null) {
                    this.channel = channel
                    resolve(true)
                } else {
                    console.log('No channel')
                    resolve(false)
                }
            }).catch((error) => {
                console.log('Error get chanel: ', error)
                //reject(error)
                resolve(false)
            })
        })
    }

    public async getAllChannels()
    {
      let channels =  await this.client.getSubscribedChannels({})
      return channels.items
    }

    public deleteChannel(channel: Channel.Channel){
        channel.delete()
        .then((channel) =>{
            console.log('channel deleted successfully', channel)
        })
        .catch(error => {
            console.log('error while deleting channel, will try to just leave it', error)
            channel.leave()
            .then(chanel =>{
                console.log('channel leaved successfully', chanel)
            })
            .catch(error => {
                console.log('error while leaving channel', error)
            })
        })
    }

    private mapMessagesObj(messages: Message.Message[]): ChatMessage[] {
        let ChatMessages: ChatMessage[] = []
        messages.map(message => {
            ChatMessages.push(this.mapMessageObj(message))
        })
        return ChatMessages
    }

    private mapMessageObj(message: Message.Message): ChatMessage {
        let chatMessage: ChatMessage =
        {
            sid: message.sid,
            author: message.author,
            body: message.body,
            dateUpdated: message.dateUpdated,
            index: message.index,
            lastUpdatedBy: message.lastUpdatedBy,
            timestamp: message.timestamp,
            attributes: message.attributes as MessageAttributes,
        }
        return chatMessage
    }
    private bindListnerToChanel(event: string, callback?: () => void) {
        if (this.channel.listenerCount(event) > 0) {
            this.channel.removeAllListeners(event)
        }
        let gg = this.channel.on(event, (args) => {
            console.log(event, ' listner callback fired', args)
            return args
        })
    }
}



// WEBPACK FOOTER //
// ./src/services/twilio/chat.ts